import { useRuntimeConfig } from "#imports";
import { CookieOptionsKeys } from "~/types/entities";
import { getParsedCookie } from "~/utils/cookies";

const APOLLO_SCRIPT_ID = "apollo-website-tracker";

declare global {
  interface Window {
    trackingFunctions?: {
      onLoad?: (config: { appId: string }) => void;
    };
  }
}

const hasAnalyticsConsent = (cookiePolicyKey: unknown): boolean => {
  if (typeof cookiePolicyKey !== "string" || !cookiePolicyKey) {
    return false;
  }

  return Boolean(
    getParsedCookie(cookiePolicyKey)?.[CookieOptionsKeys.Analytical]
  );
};

const initApollo = () => {
  if (import.meta.server) {
    return;
  }
  const config = useRuntimeConfig();

  const appId = config.public.apolloAppId;
  if (
    !config.public.isSportbenefitBrand ||
  typeof appId !== "string" ||
  !appId ||
  !hasAnalyticsConsent(config.public.cookiePolicyKey) ||
  document.getElementById(APOLLO_SCRIPT_ID)
  ) {
    return;
  }

  const random = Math.random().toString(36).substring(7);
  const script = document.createElement("script");

  script.id = APOLLO_SCRIPT_ID;
  script.src = `https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache=${random}`;

  script.async = true;
  script.defer = true;

  script.onload = () => {
    window.trackingFunctions?.onLoad?.({ appId });
  };

  document.head.appendChild(script);
};

export default initApollo;
